<div class="calls-report">
  <app-page-title icon="fa-phone" title="Ligações Enviadas"></app-page-title>

  <div class="row" *ngIf="error">
    <div class="col">
      <p class="card gradient-row danger">{{ error }}</p>
    </div>
  </div>

  <form (submit)="search()">
    <div class="row">
      <div class="col-md-6">
        <app-month-picker [min]="minDate" [max]="maxDate" (monthAndYear)="onMonthAndYear($event)"></app-month-picker>
      </div>
    </div>
  </form>

  <app-skeleton *ngIf="loading" variant="table-row" [count]="8" [columns]="3"
    label="Carregando as ligações enviadas" data-testid="calls-report-loading"></app-skeleton>

  <div *ngIf="!loading && result?.length > 0; else notFound">
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Data</th>
          <th>Quantidade de ligações</th>
          <th>#</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of result">
          <td>{{ item.counter_date | date:"dd/MM/yyyy" }}</td>
          <td>{{ item.quantity }}</td>
          <td>
            <a [routerLink]="['/calls-report', item.counter_date]" *ngIf="item.quantity > 0; else noLink">
              <i class="fa fa-phone" matTooltip="Visualizar ligações enviadas do dia"></i>
            </a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="text-end"><b>Total enviado:</b></td>
          <td colspan="2">{{ totalSent }}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <ng-template #notFound>
    <div class="card" *ngIf="searchClicked && !loading">
      Nenhuma ligação enviada
    </div>
  </ng-template>

  <ng-template #noLink>
    <i class="fa fa-phone disabled" matTooltip="Nenhuma ligação enviada nesta data"></i>
  </ng-template>
</div>
